export function noTenant () {
  return { 'no-tenant-id': true };
}

export function withTenant (tenant) {
  return { 'x-tenant-id': tenant };
}

export function authBasicHeader (user, pass) {
  return { Authorization: 'Basic ' + btoa(`${user}:${pass}`) };
}

export function authHeader () {
  let token = localStorage.getItem('token');

  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}